function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useCallback } from 'react';
import { Button, Content, Dialogs, List, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import DailyHoursListEditor from "./DailyHoursListEditor.js";
import EditOverrideDialog from "./EditOverrideDialog.js";
import S from './OverridesEditor.css';
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.WeeklyHoursEditor');
export default function OverridesEditor(props) {
  const {
    value,
    model,
    eventData,
    onChange: pOnChange,
    listItemRenderer = ListItemRenderer
  } = props;
  const onChange = useCallback(({
    value: val,
    data
  }) => {
    const nValue = model.set(value, data, val);
    pOnChange({
      value: nValue,
      data: eventData
    });
  }, [value, eventData, pOnChange, model]);
  const onOpenAddDay = useCallback(() => {
    Dialogs.show({
      component: EditOverrideDialog,
      props: {
        onChange
      }
    });
  }, [onChange]);
  const onDeleteOverride = useCallback(({
    data
  }) => {
    const nValue = model.remove(value, data);
    pOnChange({
      value: nValue,
      data: eventData
    });
  }, [model, value, pOnChange, eventData]);
  const onMoveDate = useCallback((oldDate, newDate) => {
    const old = model.get(value, oldDate);
    let nValue = model.remove(value, oldDate);
    nValue = model.set(nValue, newDate, old);
    pOnChange({
      value: nValue,
      data: eventData
    });
  }, [value, model, eventData, pOnChange]);
  const onClick = useCallback(evt => {
    const {
      data,
      itemData
    } = evt;
    Dialogs.show({
      component: EditOverrideDialog,
      props: {
        value: data,
        eventData: itemData,
        onChange,
        onMoveDate
      }
    });
  }, [onChange, onMoveDate]);
  const overrides = model.entries(value).sort((a, b) => {
    return a[0] > b[0] ? 1 : -1;
  });
  return /*#__PURE__*/React.createElement(Content, {
    className: S.overrides,
    relative: true
  }, /*#__PURE__*/React.createElement(Content.Header, {
    className: S.header
  }, /*#__PURE__*/React.createElement(Text, {
    className: S.title,
    variant: "sectionTitle"
  }, t('overrides')), /*#__PURE__*/React.createElement(Text, {
    variant: "overridesDescription|bodySmall"
  }, t('overridesDescription')), /*#__PURE__*/React.createElement(Button, {
    className: S.addButton,
    onClick: onOpenAddDay,
    icon: tIcon('addDayIcon', 'fa fa-fw fa-plus'),
    variant: "operatingHoursAddOverride|secondary"
  }, t('addDay'))), /*#__PURE__*/React.createElement(Content.Area, {
    className: S.list
  }, /*#__PURE__*/React.createElement(List, {
    onClick: onClick,
    variant: "operatingHoursOverrides"
  }, /*#__PURE__*/React.createElement(List.Dynamic, {
    items: overrides,
    component: listItemRenderer,
    itemProps: {
      onDelete: onDeleteOverride
    }
  }))));
}
function ListItemRenderer(props) {
  const {
    item,
    onDelete,
    ...rest
  } = props;
  const [key, override] = item;
  return /*#__PURE__*/React.createElement(List.Item, _extends({
    item: override,
    eventData: key
  }, rest), /*#__PURE__*/React.createElement(DailyHoursListEditor, {
    value: override,
    onDelete: onDelete,
    eventData: key
  }));
}